export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) return;
  // Only register on player/pair routes (signage devices), not the admin dashboard
  const p = window.location.pathname;
  if (!p.startsWith("/player") && !p.startsWith("/pair")) return;
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .catch((err) => console.warn("SW register failed:", err));
  });
}
